var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"catalog"},_vm._l((_vm.arrayCatalog),function(item){return _c('vCatagogItem',{key:item.id,attrs:{"catalog_item":item},on:{"addToCart":_vm.addToCart}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }